import { TLemmaResult } from '../../../common/rest/words/wordsRest';
import {
	IMergeWordsLemmasAction,
	IWordsLemmasPendingAction,
	ISetWordsDataAction,
	ISetWordsGeneratingAction,
	TAudioWordsState,
	WORDS_SET_DATA,
	WORDS_SET_LOAD_FAILED,
	WORDS_SET_GENERATE_FAILED,
	ISetWordsGenerateFailedAction,
	ISetWordsLoadFailedAction,
	WORDS_LEMMAS_PENDING,
	WORDS_MERGE_LEMMAS,
	WORDS_SET_GENERATING,
	ISetWordsNativeAction,
	TWordsNativeState,
	WORDS_SET_NATIVE,
} from './types';

export const setWordsNativeAction = (audioId: number, native: TWordsNativeState): ISetWordsNativeAction => ({
	type: WORDS_SET_NATIVE,
	audioId,
	native,
});

export const setWordsDataAction = (audioId: number, data: TAudioWordsState): ISetWordsDataAction => ({
	type: WORDS_SET_DATA,
	audioId,
	data,
});

export const setWordsGeneratingAction = (audioId: number, generating: boolean): ISetWordsGeneratingAction => ({
	type: WORDS_SET_GENERATING,
	audioId,
	generating,
});

export const mergeWordsLemmasAction = (langCode: string, lemmas: Record<string, TLemmaResult>): IMergeWordsLemmasAction => ({
	type: WORDS_MERGE_LEMMAS,
	langCode,
	lemmas,
});

export const wordsLemmasPendingAction = (langCode: string, delta: number): IWordsLemmasPendingAction => ({
	type: WORDS_LEMMAS_PENDING,
	langCode,
	delta,
});

export const setWordsLoadFailedAction = (audioId: number, failed: boolean): ISetWordsLoadFailedAction => ({
	type: WORDS_SET_LOAD_FAILED,
	audioId,
	failed,
});

export const setWordsGenerateFailedAction = (audioId: number, failed: boolean): ISetWordsGenerateFailedAction => ({
	type: WORDS_SET_GENERATE_FAILED,
	audioId,
	failed,
});
